import React from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import './MainNavbar.css';
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useAuth } from "react-oidc-context";

const MainNavbar = () => {
  const auth = useAuth();

  return (
    <Navbar variant="dark" expand="lg">
      <Container>
        <Navbar.Brand href="#home">AutoLexi</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto px-3">
            {auth.isAuthenticated ? (
              <>
                <Nav.Link as={Link} to="/">Home</Nav.Link>
                <Nav.Link as={Link} to="/wordlist">Global Cards</Nav.Link>
                <Nav.Link as={Link} to="/help">Help</Nav.Link>
                <Nav.Link as={Link} to="/about">About</Nav.Link>
                {/* <Nav.Link href="#pricing">Books</Nav.Link> */}
                <NavDropdown title="Account" id="basic-nav-dropdown">
                  <NavDropdown.Item  as={Link} to="/account">Subscription</NavDropdown.Item>
                  {/* <NavDropdown.Item href="#action/3.2">Subscription</NavDropdown.Item> */}
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={() => auth.removeUser()}>Sign out</NavDropdown.Item>
                </NavDropdown>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/help">Help</Nav.Link>
                <Nav.Link as={Link} to="/about">About</Nav.Link>
                <Nav.Link as={Link} onClick={() => auth.signinRedirect()}>Sign In</Nav.Link>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export { MainNavbar }